import { render } from "./Index.vue?vue&type=template&id=12f04f17&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=12f04f17&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f04f17"]])

export default __exports__